module.exports = __webpack_public_path__ + "static/maple-50241bc328bb63181c833b31156d3a50.png";